import React from 'react';
import { useTranslation } from 'react-i18next';
import KpiWidget from './KpiWidget';

const SessionsKpiWidget = ({ totalSessions = 0 }) => {
  const { t } = useTranslation();

  return (
    <KpiWidget
      label={t('dashboard.sessions')}
      value={totalSessions.toLocaleString()}
      hint={t('dashboard.currentWeek')}
    />
  );
};

export default SessionsKpiWidget;
